import { observer } from "mobx-react-lite";

import { ColorGrid } from "@/components/color-palette/ColorPalette";
import { getPopoverRange } from "@/components/tiptap/editor-popover/EditorPopover";

import type { DocumentModel } from "@/models/DocumentModel";
import type { Color } from "@corca/data";

export const TextColorPopover = observer(function TextColorPopover({
  doc,
}: {
  doc: DocumentModel;
}) {
  const { tiptap, editorState } = doc.editor;
  if (!tiptap) {
    return null;
  }

  const handleSelect = (color: Color) => {
    const range = getPopoverRange(tiptap.state);
    if (range) {
      tiptap.chain().setTextSelection(range).setColor(color).run();
    }
  };

  return (
    <ColorGrid
      type="text"
      currentColor={editorState.textColor ?? "black"}
      onSelect={handleSelect}
    />
  );
});
